import TopNews from './TopNews';

export default TopNews;
